import createResource from '../api/resources'
import axios from 'axios';

export default {
    install(app) {
        const axiosResource = createResource(axios)

        const resources = {
            users: axiosResource('users'),
            groups: axiosResource('groups'),
            devices: axiosResource('devices'),
            solvents: axiosResource('solvents'),
            experiences: axiosResource('experiences'),
            analyses: axiosResource('analyses'),
        }

        app.config.globalProperties.$resources = resources;
    }
 }